"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _redux = require("redux");

var _reactRedux = require("react-redux");

var _form = require("../../actions/form");

var _ControlSubmit = require("../../components/ControlSubmit");

var _ControlSubmit2 = _interopRequireDefault(_ControlSubmit);

var _locale = require("../../locale");

var _locale2 = _interopRequireDefault(_locale);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function formStep(Component) {
  var FormStep = function (_React$Component) {
    _inherits(FormStep, _React$Component);

    function FormStep(props) {
      _classCallCheck(this, FormStep);

      var _this = _possibleConstructorReturn(this, (FormStep.__proto__ || Object.getPrototypeOf(FormStep)).call(this, props));

      _this.state = {
        submitEnabled: false,
        isSubmit: _this.props.isSubmit
      };
      _this.enableSubmit = _this.enableSubmit.bind(_this);
      _this.disableSubmit = _this.disableSubmit.bind(_this);
      _this.onSubmit = _this.onSubmit.bind(_this);
      _this.resetForm = _this.resetForm.bind(_this);
      return _this;
    }

    _createClass(FormStep, [{
      key: "enableSubmit",
      value: function enableSubmit() {
        this.setState({
          submitEnabled: true
        });
      }
    }, {
      key: "disableSubmit",
      value: function disableSubmit() {
        this.setState({
          submitEnabled: false
        });
      }
    }, {
      key: "onSubmit",
      value: function onSubmit(e) {
        e.preventDefault();

        var _childForm$getFormDat = this.childForm.getFormData(),
            stepId = _childForm$getFormDat.stepId,
            formData = _childForm$getFormDat.formData;

        this.props.submit(stepId, formData);

        if (this.state.isSubmit) {
          this.props.submitReservation();
        }
      }
    }, {
      key: "resetForm",
      value: function resetForm(e) {
        e.preventDefault();
        this.props.resetForm();
      }
    }, {
      key: "renderAdditionalInformation",
      value: function renderAdditionalInformation() {
        return _react2.default.createElement("div", {
          className: "group"
        }, _react2.default.createElement("div", {
          className: "txt"
        }, _react2.default.createElement("p", {
          dangerouslySetInnerHTML: {
            __html: _locale2.default.getResource("otb_SummaryAdditionalInformation", [this.props.dataPrivacyUrl])
          }
        })));
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        return _react2.default.createElement("form", {
          className: "step",
          onSubmit: this.onSubmit
        }, _react2.default.createElement(Component, _extends({
          ref: function ref(_ref) {
            return _this2.childForm = _ref;
          }
        }, this.props, {
          submit: function submit(data) {
            return console.log(data);
          },
          enableSubmit: function enableSubmit() {
            return _this2.enableSubmit();
          },
          disableSubmit: function disableSubmit() {
            return _this2.disableSubmit();
          }
        })), this.state.isSubmit && this.renderAdditionalInformation(), _react2.default.createElement("div", {
          className: "control"
        }, _react2.default.createElement("button", {
          onClick: this.resetForm
        }, "Abbrechen"), _react2.default.createElement(_ControlSubmit2.default, {
          isValid: this.state.submitEnabled,
          isSubmit: this.state.isSubmit
        })));
      }
    }]);

    return FormStep;
  }(_react2.default.Component);

  FormStep.propTypes = {};
  return FormStep;
}

function mapDispatchToProps(dispatch) {
  return {
    resetForm: function resetForm() {
      dispatch((0, _form.resetFormData)());
    },
    submit: function submit(stepId, formData) {
      dispatch((0, _form.submitFormData)(formData));
      dispatch((0, _form.finishStep)(stepId));
      dispatch((0, _form.selectNextStep)());
    },
    submitReservation: function submitReservation() {
      return dispatch((0, _form.submitReservation)());
    }
  };
}

function mapStateToProps(state) {
  var _state$form = state.form,
      currentStep = _state$form.currentStep,
      steps = _state$form.steps;
  var isSubmit = currentStep === steps[steps.length - 1];
  var externalPrivacyUrl = state.formData.garageId ? state.garage.garages[state.formData.garageId].ExternalPrivacyUrl : "#";
  return {
    isSubmit: isSubmit,
    dataPrivacyUrl: externalPrivacyUrl
  };
}

exports.default = (0, _redux.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), formStep);